import { apiSlice } from './baseApi';
import { DEFAULT_PAGE_LIMIT } from '@constants/appDefaults';

export const expenseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExpenses: builder.query({
      query: ({ companyId, tableFilterOutcomingData, page, limit = DEFAULT_PAGE_LIMIT }) => ({
        url: '/expense/get-all-expense',
        method: 'POST',
        body: {
          company_id: companyId,
          tableFilterOutcomingData,
          page,
          limit,
        },
      }),
      transformResponse: (response) => ({
        expenses: response?.expenses ?? [],
        totalPages: response?.totalPages ?? 1,
        allTimeSum: response?.allTimeSum ?? 0,
      }),
      providesTags: ['Expenses'],
    }),
    deleteExpense: builder.mutation({
      query: (body) => ({
        url: '/expense/delete-expense',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Expenses', 'AccountCodeAmounts'],
    }),
    addExpense: builder.mutation({
      query: (body) => ({
        url: '/expense/add-new-expense',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Expenses', 'AccountCodeAmounts'],
    }),
    editExpense: builder.mutation({
      query: (body) => ({
        url: '/expense/edit-expense',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Expenses', 'AccountCodeAmounts'],
    }),
  }),
});
